"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpMetaModel = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.OpMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('ops'),
    queryName: 'opsElastic',
    alwaysGetGqlFields: 'isAdhoc, updatedDate',
    aggQueryName: 'opsAggregation',
    canSaveReports: true,
    canExportData: true,
    canExportPDF: true,
    filterables: [
        QueryFieldKey_1.default.KEYWORD,
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.STAFF,
        QueryFieldKey_1.default.TEAM,
        QueryFieldKey_1.default.OPDEFINITION_HIDDEN,
        QueryFieldKey_1.default.OPS_TYPE,
        QueryFieldKey_1.default.OP_HASISSUES,
        QueryFieldKey_1.default.OP_STARTFROM,
        QueryFieldKey_1.default.OP_COMPLETEBY,
        QueryFieldKey_1.default.OP_ACTUALSTART,
        QueryFieldKey_1.default.OP_ACTUALCOMPLETE,
        QueryFieldKey_1.default.OP_STATUS,
        QueryFieldKey_1.default.OP_SCORE,
        QueryFieldKey_1.default.OP_GRADE,
        QueryFieldKey_1.default.OP_PASSSTATUS,
    ],
    groupables: [
        QueryFieldKey_1.default.OP_STARTFROM,
        QueryFieldKey_1.default.OP_COMPLETEBY,
        QueryFieldKey_1.default.OP_ACTUALSTART,
        QueryFieldKey_1.default.OP_ACTUALCOMPLETE,
        QueryFieldKey_1.default.OP_STATUS,
        QueryFieldKey_1.default.OPS_TYPE,
        QueryFieldKey_1.default.OPDEFINITION,
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.TEAM,
        QueryFieldKey_1.default.OP_GRADE,
        QueryFieldKey_1.default.OP_PASSSTATUS,
    ],
    fields: [
        ViewFieldKey_1.default.ID,
        ViewFieldKey_1.default.TITLE,
        ViewFieldKey_1.default.PLACE,
        ViewFieldKey_1.default.OP_STARTFROM,
        ViewFieldKey_1.default.OP_STATUS,
        ViewFieldKey_1.default.OP_SUBMITTEDBY,
        ViewFieldKey_1.default.OPS_TYPE,
        ViewFieldKey_1.default.OP_ISADHOC,
        ViewFieldKey_1.default.OP_ISSUES,
        ViewFieldKey_1.default.OPS_ASSIGNEE,
        ViewFieldKey_1.default.OPS_ASSOCIATED_STAFF,
        ViewFieldKey_1.default.OP_COMPLETEBY,
        ViewFieldKey_1.default.OP_ACTUALSTART,
        ViewFieldKey_1.default.OP_ACTUALCOMPLETE,
        ViewFieldKey_1.default.OP_SCORE,
        ViewFieldKey_1.default.OP_GRADE,
        ViewFieldKey_1.default.OP_PASSSTATUS,
    ],
});
exports.default = exports.OpMetaModel;
